import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError, InteractionType } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class JWTserviceService {

  constructor(private msalService: MsalService) {}

  refreshToken() {
      const request = {
          scopes: ['user.read'], // The same scopes used when acquiring the token
      };

      this.msalService.acquireTokenSilent(request).subscribe({
          next: () => {
              // Do not log the MSAL result: it contains the raw access/ID tokens.
              console.log('Token refreshed successfully!');
          },
          error: (error) => {
              console.error('Token refresh failed:', error);
              // You may want to redirect to login if silent token acquisition fails
              if (error instanceof InteractionRequiredAuthError) {
                  this.msalService.acquireTokenRedirect(request);
              }
          }
      });
  }

  acquireToken() {
    const activeAccount = this.msalService.instance.getAllAccounts()[0]; // Get the first account

    if (activeAccount) {
        const request = {
            scopes: ['user.read'], // Your scopes
            account: activeAccount // Specify the active account
        };

        this.msalService.acquireTokenSilent(request).subscribe({
            next: (result) => {
                localStorage.setItem('bearer_token', result.idToken);
            },
            error: (error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    this.msalService.acquireTokenRedirect(request);
                } else {
                    console.error('Token acquisition failed:', error);
                }
            }
        });
    } else {
        console.log('No active account found. Please log in.');
    }
}

}
